{
  "schemaVersion": 1,
  "contentDate": "2026-08-12",
  "source": "Enciclopédia oficial de Avernor",
  "chapter": "capitulo-zero-o-grito-na-floresta",
  "records": [
    {
      "collection": "characters",
      "id": "sirius-kayler",
      "slug": "sirius-kayler",
      "name": "Sirius Kayler",
      "subtitle": "O último bruxo conhecido",
      "summary": "Filho de Normus Kayler e Namídia Bellatrix, herdeiro de uma linhagem perseguida e de um pacto secreto com Sylvaris.",
      "description": "Sirius nasceu escondido na Floresta Antiga durante os últimos anos da Caça às Bruxas. Herdou a magia de tempestade dos Kayler, mas cresceu sem conhecer a extensão do preço pago por seus pais. Apesar da idade extraordinária, conserva aparência jovem. O domínio de seus poderes depende de controle emocional: descargas intensas ferem nervos, atraem atenção e podem incendiar o ambiente que tenta proteger.",
      "category": "Protagonista",
      "status": "Vivo",
      "origin": "Floresta Antiga",
      "location": "Em jornada",
      "period": "Era atual — 1204 d.C.",
      "race": "Humano — linhagem bruxa",
      "lineage": "Kayler",
      "appearance": "Sirius é alto, de físico atlético e musculatura construída por séculos de sobrevivência, treinamento e deslocamento por regiões hostis. Possui pele morena, cabelos longos e brancos normalmente trançados, olhos violetas que se intensificam quando a mana se acumula, cicatrizes no rosto e no corpo e um bigode escuro. Sua aparência jovem contrasta com a quietude de alguém que observou gerações inteiras nascerem e desaparecerem. Em repouso, parece vigilante; sob tempestade, a eletricidade percorre discretamente seus cabelos, cicatrizes e placas de armadura.",
      "personality": "Sirius observa antes de falar e raramente oferece confiança sem prova concreta. O isolamento o tornou autossuficiente, mas não indiferente: reage com rapidez quando alguém vulnerável é tratado como recurso político. Seu humor é seco e aparece sobretudo quando o medo ameaça dominar um grupo.",
      "speech": "Fala em frases curtas, evita títulos e faz perguntas literais. Quando irritado, abandona metáforas e descreve diretamente o preço de uma decisão.",
      "objectives": [
        "Descobrir o que Normus ocultou sem entregar sua autonomia às coroas",
        "Proteger possíveis sobreviventes Nimbus e Rivs",
        "Compreender o pacto com Sylvaris antes de aceitá-lo ou recusá-lo"
      ],
      "desires": [
        "Encontrar pertencimento sem perder autonomia",
        "Conhecer os pais para além das versões heroicas",
        "Descobrir se a palavra “último” descreve um fato ou apenas a falta de registros"
      ],
      "fears": [
        "Tornar-se uma arma de Estado",
        "Ferir inocentes durante uma sobrecarga",
        "Descobrir que sua sobrevivência custou mais vidas do que consegue suportar"
      ],
      "flaws": [
        "Isolamento prolongado tornou confiança e negociação difíceis",
        "Confunde autocontrole com silêncio emocional",
        "Pode responder à manipulação tentando resolver tudo sozinho"
      ],
      "qualities": [
        "Lealdade perseverante depois que confia",
        "Capacidade de suportar desconforto sem transferi-lo aos outros",
        "Recusa em medir o valor de uma pessoa por sangue ou título"
      ],
      "values": [
        "Consentimento",
        "Proteção de civis",
        "Verdade acompanhada de responsabilidade"
      ],
      "moralLimits": [
        "Não aceitará uma coroa baseada em poder arcano",
        "Não usará uma população como isca",
        "Não entregará uma criança marcada por magia a qualquer Estado"
      ],
      "beliefs": [
        "Poder não concede direito de governo",
        "Memória sem escolha pode tornar-se outra prisão"
      ],
      "equipment": [
        "Fulgarion, a espada herdada de Normus",
        "Carta cifrada",
        "Medalhão do pacto de Sylvaris",
        "Armadura original de influência oriental; depois, manto negro com capuz"
      ],
      "abilities": [
        "Magia hereditária de tempestade",
        "Condução de raios pela espada",
        "Metamorfose do Eco em corvo de olhos violetas",
        "Combate de curta distância",
        "Resistência arcana acima do comum"
      ],
      "limitations": [
        "Sobrecarga provoca tremores e perda de sensibilidade",
        "Não cria tempestades sem umidade atmosférica",
        "Fulgarion e equipamentos pesados não acompanham a forma de corvo",
        "É reconhecível pelos olhos violetas em ambas as formas"
      ],
      "relations": [
        {
          "label": "Normus Kayler — pai",
          "to": "/personagens/normus-kayler"
        },
        {
          "label": "Namídia Bellatrix — mãe",
          "to": "/personagens/namidia-bellatrix"
        },
        {
          "label": "Elara — aliada ligada ao pacto",
          "to": "/personagens/elara"
        },
        {
          "label": "Genealogia Kayler",
          "to": "/personagens/sirius-kayler/genealogia"
        },
        {
          "label": "Casa Kayler",
          "to": "/casas/kayler"
        },
        {
          "label": "Fulgarion",
          "to": "/reliquias/fulgarion"
        },
        {
          "label": "Caça às Bruxas",
          "to": "/historia/caca-bruxas"
        }
      ],
      "events": [
        "Nascimento secreto na Floresta Antiga",
        "Recebimento da herança de Normus",
        "Resgate de Elara na clareira dos três mercenários orcs"
      ],
      "curiosities": [
        "Carrega uma carta de Normus que ainda não revelou a terceiros.",
        "Evita usar magia perto de crianças por medo de perder o controle."
      ],
      "quotes": [
        "Sobreviver não torna ninguém inteiro. Apenas oferece tempo para escolher o que fazer com as partes."
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/characters/sirius-kayler-page.webp",
      "thumbnail": "/assets/images/characters/sirius-kayler-card.webp"
    },
    {
      "collection": "characters",
      "id": "elara",
      "slug": "elara",
      "name": "Elara",
      "subtitle": "A herdeira do caminho oculto",
      "summary": "Jovem princesa élfica, guerreira, sobrinha da Rainha de Sylvaris e portadora de uma adaga rúnica de teletransporte.",
      "description": "Elara foi educada para governar um reino que considera memória e ecologia partes da mesma lei. Sua baixa estatura nunca limitou sua presença no campo. A adaga rúnica abre saltos breves entre pontos que ela consiga ver ou tenha marcado previamente; cada uso drena calor corporal e pode deixá-la desorientada. O pacto feito por sua tia e Normus liga seu futuro ao de Sirius, mas não determina seus sentimentos nem suas escolhas.",
      "category": "Herdeira",
      "status": "Viva",
      "origin": "Lethariel",
      "location": "Floresta Antiga",
      "period": "Era atual",
      "kingdom": "Sylvaris",
      "race": "Elfa",
      "appearance": "Elara é baixa, ágil e treinada para deslocamento em copas, raízes e passagens estreitas. Possui cabelos loiros geralmente presos em tranças de viagem e olhos dourados que refletem a luz das folhas. Sua aparência jovem contrasta com uma postura disciplinada, construída por anos observando conselhos e patrulhas. Fora da corte, evita símbolos de herdeira e prefere roupas leves de malha vegetal, manto verde e luvas para proteger as mãos do frio provocado pela adaga rúnica.",
      "personality": "Atenta, rápida em formar opinião e relutante em obedecer a motivos não explicados. Elara combina compaixão com impaciência e prefere testar uma regra no terreno antes de defendê-la em conselho.",
      "speech": "Precisa, com perguntas rápidas; usa formalidade na corte e a abandona quando percebe evasão.",
      "objectives": [
        "Ser reconhecida por escolhas, não apenas pelo pacto herdado",
        "Preparar-se para governar sem tratar a floresta como recurso da coroa",
        "Descobrir por que a tia protege um herdeiro Kayler que ela ainda não conhece no início da saga"
      ],
      "desires": [
        "Governar sem ser governada pelo pacto",
        "Preservar vínculo verdadeiro com as irmãs",
        "Conhecer o mundo além das versões filtradas pela corte"
      ],
      "fears": [
        "Que Aelysar e o trono substituam sua liberdade por função",
        "Que a adaga falhe com outra pessoa em trânsito"
      ],
      "flaws": [
        "Teimosia diante de autoridade que não explicou seus motivos",
        "Age antes de pedir apoio quando acredita que o conselho demorará"
      ],
      "qualities": [
        "Coragem",
        "Leitura de ambiente",
        "Capacidade de admitir erro depois de confrontá-lo"
      ],
      "values": [
        "Escolha consciente",
        "Reciprocidade com a floresta",
        "Responsabilidade de quem herda poder"
      ],
      "moralLimits": [
        "Não aceitará Aelysar antes da coroação legítima",
        "Não entregará alguém ao conselho apenas por origem"
      ],
      "beliefs": [
        "A floresta participa das decisões",
        "Juramentos herdados só valem quando escolhidos"
      ],
      "equipment": [
        "Adaga do Passo Velado",
        "Marcadores de prata para rotas seguras",
        "Aelysar será entregue apenas no trono"
      ],
      "abilities": [
        "Combate com adaga",
        "Teletransporte rúnico de curto alcance",
        "Rastreamento florestal",
        "Diplomacia de Sylvaris"
      ],
      "limitations": [
        "Saltos exigem concentração, esforço físico e visão ou marca prévia",
        "O destino precisa oferecer uma área segura de chegada",
        "A adaga não corrige um ponto de pouso perigoso",
        "Uso repetido causa hipotermia e vertigem",
        "Não atravessa barreiras de ferro meteórico"
      ],
      "relations": [
        {
          "label": "Rainha Aelwen — tia",
          "to": "/personagens/rainha-aelwen"
        },
        {
          "label": "Sirius Kayler — aliado ligado pelo pacto",
          "to": "/personagens/sirius-kayler"
        },
        {
          "label": "Genealogia real",
          "to": "/personagens/elara/genealogia"
        },
        {
          "label": "Sucessão de Sylvaris",
          "to": "/sucessoes/sylvaris"
        },
        {
          "label": "Sylvaris",
          "to": "/reinos/sylvaris"
        },
        {
          "label": "Aelysar",
          "to": "/reliquias/aelysar"
        }
      ],
      "events": [
        "Juramento da Herdeira",
        "Primeiro salto além de Sylvaris",
        "Encontro com Sirius"
      ],
      "curiosities": [
        "Marca rotas seguras com fios de prata quase invisíveis."
      ],
      "quotes": [
        "Um juramento herdado ainda precisa ser escolhido por quem o carrega."
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/characters/elara-page.webp",
      "thumbnail": "/assets/images/characters/elara-card.webp"
    },
    {
      "collection": "characters",
      "id": "rainha-aelwen",
      "slug": "rainha-aelwen",
      "name": "Rainha Aelwen",
      "subtitle": "Guardadora da Memória de Sylvaris",
      "summary": "Soberana élfica, tia de Elara, grande amiga de Normus e guardiã do pacto secreto firmado com ele.",
      "description": "Aelwen governa por escuta e demora calculada, métodos que estrangeiros confundem com hesitação. Durante a Caça às Bruxas, abriu caminhos de Sylvaris para refugiados e aceitou o risco de proteger o filho de Normus. A amizade entre os dois nasceu no campo de batalha e permaneceu inteiramente fraterna e política.",
      "category": "Soberana",
      "status": "Viva",
      "origin": "Lethariel",
      "location": "Sylvaris",
      "period": "Era das Coroas / Era atual",
      "kingdom": "Sylvaris",
      "race": "Elfa",
      "appearance": "Aelwen possui cabelos claros presos com fibras vivas, olhos verde-dourados e postura régia marcada mais por quietude do que por ostentação. Suas vestes de fibras verdes, marfim e ouro são cultivadas sem o corte de árvores vivas. Retratos antigos a mostram com arco e armadura de sentinela; os atuais destacam mãos marcadas por escrita, jardinagem ritual e séculos de governo.",
      "personality": "Deliberada, cortês e capaz de sustentar silêncio sob pressão. Sua prudência protegeu vidas, mas também concentrou segredos.",
      "speech": "Formal e pausada; distingue cuidadosamente fato, testemunho e interpretação.",
      "objectives": [
        "Preparar Elara para escolher a sucessão conscientemente",
        "Cumprir o pacto com Normus sem governar Sirius",
        "Evitar que o segredo divida os Círculos da Memória"
      ],
      "desires": [
        "Entregar a Elara um reino capaz de discordar da própria coroa",
        "Cumprir o pacto sem possuir o futuro de Sirius"
      ],
      "fears": [
        "Que a proteção se transforme em tutela",
        "Que revelar o pacto cedo demais provoque outra perseguição"
      ],
      "flaws": [
        "A demora calculada pode negar informação a quem precisa decidir",
        "Carrega sozinha parte excessiva do pacto"
      ],
      "qualities": [
        "Memória política",
        "Diplomacia",
        "Firmeza sem culto à autoridade"
      ],
      "values": [
        "Reciprocidade",
        "Memória pública",
        "Limitação do poder"
      ],
      "moralLimits": [
        "Não transformar amizade em reivindicação de sangue",
        "Não usar o pacto para obrigar Sirius ou Elara"
      ],
      "beliefs": [
        "Amizade e lealdade não implicam romance",
        "Uma coroa é função limitada pela memória coletiva"
      ],
      "abilities": [
        "Diplomacia",
        "Memória ritual élfica",
        "Comando das sentinelas",
        "Arqueira cerimonial"
      ],
      "limitations": [
        "Sua autoridade é limitada pelos Círculos da Memória",
        "O pacto com Normus divide seu conselho"
      ],
      "relations": [
        {
          "label": "Elara — sobrinha e herdeira",
          "to": "/personagens/elara"
        },
        {
          "label": "Normus Kayler — amigo e aliado",
          "to": "/personagens/normus-kayler"
        },
        {
          "label": "Sylvaris",
          "to": "/reinos/sylvaris"
        },
        {
          "label": "Sucessão de Sylvaris",
          "to": "/sucessoes/sylvaris"
        }
      ],
      "events": [
        "Defesa de Sylvaris",
        "Pacto dos Descendentes",
        "Abrigo de Sirius"
      ],
      "quotes": [
        "Guardar um segredo é também responder pelo que ele impede o mundo de escolher."
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/characters/rainha-sylvaris-page.webp",
      "thumbnail": "/assets/images/characters/rainha-sylvaris-card.webp"
    },
    {
      "collection": "characters",
      "id": "normus-kayler",
      "slug": "normus-kayler",
      "name": "Normus Kayler",
      "subtitle": "O Bruxo mais poderoso de Avernor",
      "summary": "Bruxo da Casa Kayler, mestre das tempestades, Cavaleiro de Honra de Sylvaris e pai de Sirius.",
      "description": "Normus foi a força arcana mais poderosa registrada em Avernor. Não era um guerreiro humano que aprendera feitiços, mas um bruxo hereditário cuja disciplina transformava tempestades em defesa precisa. Recusou coroas e serviu comunidades ameaçadas. A Rainha de Sylvaris foi sua grande amiga e aliada — nunca amante. Entre ambos existiu um pacto secreto relacionado aos descendentes de suas casas.",
      "category": "Figura histórica",
      "status": "Morto — lendário",
      "origin": "Casa Kayler",
      "location": "Último registro: Floresta Antiga",
      "period": "Era das Coroas / Caça às Bruxas",
      "race": "Humano — linhagem bruxa",
      "lineage": "Kayler",
      "appearance": "Normus era alto e robusto, aparentava cerca de quarenta anos, tinha cabelos longos, brancos e grisalhos presos durante o combate, olhos violetas intensos e marcas de descarga nos braços, ombros e tórax. Usava uma armadura de campanha reparada em Kar-Dûm, dotada de canais metálicos para conduzir energia. Não utilizava coroa, brasão real ou símbolos de vassalagem. Retratos élficos o mostram sereno; gravuras humanas, ameaçador; registros anões, concentrado sobre mecanismos e mapas.",
      "personality": "Paciente sob ameaça imediata e impaciente diante de injustiças administrativas. Normus tratava poder como dívida e desconfiava da admiração que dispensava as pessoas de contestá-lo.",
      "speech": "Falava lentamente em conselho e rapidamente no campo, sempre nomeando o custo material de uma estratégia.",
      "objectives": [
        "Impedir que coroas convertessem bruxos em soberanos ou armas",
        "Preservar Sirius como pessoa livre",
        "Manter abertas rotas civis durante as guerras"
      ],
      "desires": [
        "Deixar ao filho escolhas reais",
        "Ver as três Casas protegidas por lei, não por favor"
      ],
      "fears": [
        "Que o próprio prestígio anulasse o Juramento Arcano",
        "Que Sirius herdasse apenas inimigos e não escolhas"
      ],
      "flaws": [
        "Assumiu responsabilidades que deveriam ter sido distribuídas",
        "Escondeu verdades de aliados para protegê-los, reduzindo sua capacidade de consentir"
      ],
      "qualities": [
        "Precisão arcana",
        "Coragem sem busca por domínio",
        "Capacidade de cooperar com culturas diferentes"
      ],
      "values": [
        "Responsabilidade",
        "Autonomia dos povos",
        "Proteção de rotas civis"
      ],
      "moralLimits": [
        "Nunca governar em razão do sangue",
        "Nunca usar tempestade sobre população sem rota de fuga"
      ],
      "beliefs": [
        "“Nenhum sangue tocado pelo Primeiro Céu deverá sentar-se acima dos povos.”",
        "A Rainha de Sylvaris era amiga e aliada"
      ],
      "equipment": [
        "Fulgarion",
        "Armadura de campanha reparada em Kar-Dûm",
        "Medalhão da Folha Partida"
      ],
      "abilities": [
        "Domínio arcano superior",
        "Condução e dispersão de tempestades",
        "Barreiras elétricas",
        "Leitura de campos mágicos"
      ],
      "limitations": [
        "A escala de seus feitos exigia recuperação prolongada",
        "Recusava magia que sacrificasse inocentes",
        "O vínculo com tempestades não anulava leis naturais"
      ],
      "relations": [
        {
          "label": "Sirius Kayler — filho",
          "to": "/personagens/sirius-kayler"
        },
        {
          "label": "Namídia Bellatrix — companheira",
          "to": "/personagens/namidia-bellatrix"
        },
        {
          "label": "Rainha Aelwen — amiga e aliada",
          "to": "/personagens/rainha-aelwen"
        },
        {
          "label": "Casa Kayler",
          "to": "/casas/kayler"
        },
        {
          "label": "Sylvaris",
          "to": "/reinos/sylvaris"
        },
        {
          "label": "Fulgarion",
          "to": "/artefatos/espada-da-trovoada"
        },
        {
          "label": "Caça às Bruxas",
          "to": "/historia/caca-bruxas"
        }
      ],
      "events": [
        "Defesa de Sylvaris",
        "Nomeação como Cavaleiro de Honra",
        "Pacto dos Descendentes",
        "Fuga para a Floresta Antiga"
      ],
      "curiosities": [
        "Foi o único não elfo a receber o título de Cavaleiro de Honra de Sylvaris.",
        "Deixou a Sirius espada, carta, ouro, medalhão élfico e pertences de viagem."
      ],
      "quotes": [
        "Poder sem limite não existe. Existe apenas alguém que decidiu fazer outro pagar o custo."
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/characters/normus-kayler-v2-page.webp",
      "thumbnail": "/assets/images/characters/normus-kayler-v2-card.webp"
    },
    {
      "collection": "characters",
      "id": "namidia-bellatrix",
      "slug": "namidia-bellatrix",
      "name": "Namídia Bellatrix",
      "subtitle": "Princesa da fortaleza rebelde",
      "summary": "Líder das Montanhas Cinzentas que acolheu Normus, tornou-se sua companheira e morreu protegendo o filho Sirius.",
      "description": "Namídia cresceu administrando estoques de cerco, rotas de fuga e alianças entre fortalezas que desconfiavam umas das outras. O título de princesa dos Bellatrix significava responsabilidade, não luxo. Ela se apaixonou por Normus ao perceber que o bruxo mais poderoso do continente ainda pedia permissão antes de agir em território rebelde. Fugiu com ele e morreu mantendo os perseguidores longe de Sirius.",
      "category": "Figura histórica",
      "status": "Morta — lendária",
      "origin": "Fortaleza do Véu",
      "location": "Montanhas Cinzentas",
      "period": "Caça às Bruxas",
      "race": "Humana",
      "lineage": "Bellatrix",
      "appearance": "Namídia era uma mulher parda de postura firme, cabelos negros presos para trabalho e olhos castanhos atentos que acompanhavam portas, mensageiros e mudanças de humor. Uma lesão antiga limitava o ombro direito. Vestia lã escura, couro reforçado e a faixa vermelha dos vigias, evitando joias e símbolos de ostentação. Sua autoridade era reconhecida pela segurança com que organizava pessoas e recursos, não por cerimônia.",
      "personality": "Prática, afetuosa sem sentimentalismo público e intolerante com autoridade que não assume consequências. Namídia preferia perguntas logísticas a discursos heroicos.",
      "speech": "Direta, marcada por exemplos concretos de estoque, distância e tempo.",
      "objectives": [
        "Manter a Fortaleza do Véu aberta a perseguidos",
        "Unir fortalezas sem criar outra coroa",
        "Garantir que Sirius sobrevivesse sem se tornar propriedade política"
      ],
      "desires": [
        "Uma rede de abrigo que sobrevivesse a qualquer líder",
        "Criar Sirius longe da obrigação de vingar os pais"
      ],
      "fears": [
        "Que a resistência reproduzisse a tirania combatida",
        "Que cifras e segredos apagassem as pessoas que deveriam proteger"
      ],
      "flaws": [
        "Aceitava riscos pessoais extremos para não transferi-los a subordinados",
        "Podia transformar responsabilidade em recusa de ajuda"
      ],
      "qualities": [
        "Coragem civil",
        "Memória de nomes e necessidades",
        "Capacidade de formar coalizões"
      ],
      "values": [
        "Hospitalidade juramentada",
        "Prestação de contas",
        "Liberdade política"
      ],
      "moralLimits": [
        "Não devolver refugiados",
        "Não esconder perdas de quem sustentou a defesa"
      ],
      "beliefs": [
        "A Chama sem Coroa",
        "Juramento ao povo supera juramento ao trono"
      ],
      "equipment": [
        "Caderno cifrado",
        "Fivelas de mensageiro",
        "Chaves de depósitos descentralizados"
      ],
      "abilities": [
        "Estratégia de cerco",
        "Negociação entre fortalezas",
        "Combate defensivo",
        "Criptografia Bellatrix"
      ],
      "limitations": [
        "Não possuía magia verdadeira",
        "Sofria com uma lesão antiga no ombro",
        "Seu título dependia da confiança dos vigias"
      ],
      "relations": [
        {
          "label": "Normus Kayler — companheiro",
          "to": "/personagens/normus-kayler"
        },
        {
          "label": "Sirius Kayler — filho",
          "to": "/personagens/sirius-kayler"
        },
        {
          "label": "Casa Bellatrix",
          "to": "/casas/bellatrix"
        }
      ],
      "events": [
        "Acolhimento de Normus",
        "Fuga para a Floresta Antiga",
        "Sacrifício pela sobrevivência de Sirius"
      ],
      "curiosities": [
        "Suas cifras usavam variações de inventários de grãos para ocultar nomes."
      ],
      "quotes": [
        "Abrigo não é o lugar onde o medo termina. É onde ninguém precisa enfrentá-lo sozinho."
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/characters/namidia-bellatrix-v2-page.webp",
      "thumbnail": "/assets/images/characters/namidia-bellatrix-v2-card.webp"
    },
    {
      "collection": "kingdoms",
      "id": "sylvaris",
      "slug": "sylvaris",
      "name": "Sylvaris",
      "subtitle": "O coração vivo da Floresta Antiga",
      "summary": "Reino élfico protegido por árvores milenares, sentinelas e caminhos que se transformam sob orientação dos guardiões.",
      "description": "Sylvaris não separa cidade e floresta: pontes crescem entre troncos, a água define bairros e construções novas exigem o consentimento de círculos de guardiões. A Rainha governa com um conselho de memórias, formado por representantes de ofícios e bosques. A amizade com Normus garantiu refúgio aos Kayler e originou um pacto secreto sobre seus descendentes.",
      "category": "Reino élfico",
      "status": "Soberano",
      "origin": "Avernor",
      "location": "Oeste e sudoeste",
      "relations": [
        {
          "label": "Elara",
          "to": "/personagens/elara"
        },
        {
          "label": "Rainha Aelwen",
          "to": "/personagens/rainha-aelwen"
        },
        {
          "label": "Lethariel",
          "to": "/cidades/lethariel"
        }
      ],
      "events": [
        "Defesa de Sylvaris",
        "Pacto dos Descendentes"
      ],
      "curiosities": [
        "Cortar uma árvore viva sem autorização é tratado como agressão política."
      ],
      "quotes": [
        "A floresta não fecha caminhos; ela decide quem está preparado para atravessá-los."
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/kingdoms/kingdom-sylvaris-page.webp",
      "thumbnail": "/assets/images/kingdoms/kingdom-sylvaris-card.webp"
    },
    {
      "collection": "locations",
      "id": "floresta-antiga",
      "slug": "floresta-antiga",
      "name": "Floresta Antiga",
      "subtitle": "Onde caminhos guardam memória",
      "summary": "Grande floresta do oeste, lar de Sylvaris e refúgio de Sirius durante a perseguição.",
      "description": "A floresta reúne zonas manejadas, áreas sagradas e regiões nunca ocupadas. Trilhas mudam porque pontes são recolhidas, vegetação cresce rápido e guardiões desviam invasores — não porque o território ignore as leis naturais.",
      "category": "Floresta",
      "status": "Protegida",
      "origin": "Avernor",
      "location": "Oeste de Avernor",
      "kingdom": "Sylvaris",
      "relations": [
        {
          "label": "Sylvaris",
          "to": "/reinos/sylvaris"
        }
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/locations/jornada-floresta-antiga-banner.webp",
      "thumbnail": "/assets/images/locations/jornada-floresta-antiga-card.webp"
    },
    {
      "collection": "portals",
      "id": "caminho-das-arvores-ausentes",
      "slug": "caminho-das-arvores-ausentes",
      "name": "Caminho das Árvores Ausentes",
      "subtitle": "Uma trilha que não pertence à estação",
      "summary": "Passagem de Sylvaris cuja vegetação muda para espécies nunca catalogadas em Avernor.",
      "description": "O Caminho das Árvores Ausentes surge em Sylvaris após certas tempestades violetas e contém espécies sem correspondência conhecida em Avernor. Folhas recolhidas mantêm anatomia coerente e depois perdem pigmento; sentinelas registram diferenças de estação e distância a cada aparição. Não se sabe se conduz a Elyra, a outro tempo da floresta ou a espaço sem mundo estável. O acesso não é convocável.",
      "category": "Fratura registrada",
      "status": "Intermitente",
      "origin": "Avernor",
      "location": "Floresta Antiga",
      "relations": [
        {
          "label": "Elyra",
          "to": "/outros-mundos/elyra"
        },
        {
          "label": "Sylvaris",
          "to": "/reinos/sylvaris"
        }
      ],
      "truthStatus": "disputed",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/atlas-plates/caminho-das-arvores-ausentes-page.webp",
      "thumbnail": "/assets/images/atlas-plates/caminho-das-arvores-ausentes-card.webp"
    },
    {
      "collection": "cities",
      "id": "lethariel",
      "slug": "lethariel",
      "name": "Lethariel",
      "subtitle": "A cidade entre raízes e estrelas",
      "summary": "Capital de Sylvaris, distribuída entre margens, plataformas vivas e salões escavados sem ferir as árvores.",
      "description": "Lethariel não possui muralha convencional. Trilhas mudam, pontes são recolhidas e sentinelas leem alterações no comportamento de aves e fungos. O Palácio da Seiva Clara guarda o pacto firmado entre Normus e a Rainha.",
      "category": "Capital",
      "status": "Habitada",
      "origin": "Avernor",
      "location": "Floresta Antiga",
      "kingdom": "Sylvaris",
      "relations": [
        {
          "label": "Sylvaris",
          "to": "/reinos/sylvaris"
        },
        {
          "label": "Elara",
          "to": "/personagens/elara"
        }
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/atlas-plates/lethariel-page.webp",
      "thumbnail": "/assets/images/atlas-plates/lethariel-card.webp"
    },
    {
      "collection": "artifacts",
      "id": "carta-de-normus",
      "slug": "carta-de-normus",
      "name": "Carta de Normus",
      "subtitle": "Palavras para um filho sem lembranças",
      "summary": "Documento selado entregue a Sirius com ouro, espada, medalhão e pertences do pai.",
      "description": "A carta explica parte da perseguição e pede que Sirius não confunda vingança com memória. Trechos finais usam uma cifra Bellatrix, possivelmente para proteger a localização de sobreviventes. O Arquivo registra sua existência, mas não publica o texto integral por escolha de Sirius.",
      "category": "Documento pessoal",
      "status": "Parcialmente decifrado",
      "origin": "Normus Kayler",
      "location": "Com Sirius",
      "period": "Caça às Bruxas",
      "appearance": "Folhas dobradas e reparadas, com texto comum interrompido por inventários aparentemente banais que ocultam a cifra Bellatrix.",
      "limitations": [
        "Cifra incompleta",
        "A leitura depende de referências do caderno de Namídia"
      ],
      "relations": [
        {
          "label": "Normus Kayler",
          "to": "/personagens/normus-kayler"
        },
        {
          "label": "Namídia Bellatrix",
          "to": "/personagens/namidia-bellatrix"
        }
      ],
      "events": [
        "Preparação do baú",
        "Leitura em 1204"
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/artifacts/carta-de-normus-page.webp",
      "thumbnail": "/assets/images/artifacts/carta-de-normus-card.webp"
    },
    {
      "collection": "artifacts",
      "id": "medalhao-da-folha-partida",
      "slug": "medalhao-da-folha-partida",
      "name": "Medalhão da Folha Partida",
      "subtitle": "Sinal do pacto entre Kayler e Sylvaris",
      "summary": "Medalhão élfico deixado por Normus entre os pertences de Sirius.",
      "description": "Duas metades de prata vegetal formam uma folha atravessada por um raio. O objeto não concede magia; serve como prova reconhecida pelos guardiões de Sylvaris. Uma das inscrições permanece cifrada e depende da metade conservada pela Rainha.",
      "category": "Insígnia diplomática",
      "status": "Preservado",
      "origin": "Sylvaris",
      "location": "Com Sirius",
      "period": "Caça às Bruxas",
      "appearance": "Folha de prata dividida por um raio. Uma borda se encaixa apenas na metade conservada por Sylvaris; isoladas, ambas parecem incompletas.",
      "limitations": [
        "Não concede acesso automático a Sylvaris",
        "Não obriga descendentes"
      ],
      "relations": [
        {
          "label": "Pacto dos Descendentes",
          "to": "/lendas/pacto-dos-descendentes"
        },
        {
          "label": "Sirius Kayler",
          "to": "/personagens/sirius-kayler"
        }
      ],
      "events": [
        "Pacto dos Descendentes",
        "Herança de Sirius"
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/artifacts/medalhao-da-folha-partida-page.webp",
      "thumbnail": "/assets/images/artifacts/medalhao-da-folha-partida-card.webp"
    },
    {
      "collection": "artifacts",
      "id": "adaga-do-passo-velado",
      "slug": "adaga-do-passo-velado",
      "name": "Adaga do Passo Velado",
      "subtitle": "A lâmina rúnica de Elara",
      "summary": "Adaga élfica capaz de transportar Elara por distâncias curtas até pontos visíveis ou previamente marcados.",
      "description": "Runas gravadas no metal dobram a distância por um instante. Cada salto exige concentração contínua, esforço físico e um destino visível ou previamente marcado que ofereça área segura para chegada. A adaga não atravessa ferro meteórico, não pode levar grandes cargas e não corrige um ponto de pouso perigoso. Cada uso retira calor do corpo da portadora; três saltos rápidos podem causar perda de consciência.",
      "category": "Artefato rúnico",
      "status": "Ativo",
      "origin": "Sylvaris",
      "location": "Com Elara",
      "period": "Era atual",
      "appearance": "Adaga estreita de prata fosca, com runas que parecem se aproximar quando o destino está marcado. A bainha possui compartimentos térmicos e fios para assinalar pontos seguros.",
      "limitations": [
        "Curto alcance",
        "Exige concentração contínua e esforço físico",
        "Requer destino seguro, visível ou previamente marcado",
        "Não corrige ponto de pouso perigoso",
        "Não atravessa ferro meteórico",
        "Carga e passageiros ampliam o risco"
      ],
      "relations": [
        {
          "label": "Elara",
          "to": "/personagens/elara"
        }
      ],
      "events": [
        "Treinamento de Elara",
        "Missão nas margens de Sylvaris"
      ],
      "curiosities": [
        "A bainha contém sais aquecedores para reduzir o risco de hipotermia."
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/artifacts/adaga-do-passo-velado-page.webp",
      "thumbnail": "/assets/images/artifacts/adaga-do-passo-velado-card.webp"
    },
    {
      "collection": "relics",
      "id": "fulgarion",
      "slug": "fulgarion",
      "name": "Fulgarion",
      "subtitle": "A Espada dos Sete Trovões",
      "summary": "Espada de Normus e Sirius, condutora do legado Kayler e uma das Cinco Relíquias.",
      "description": "Fulgarion é condutora da tempestade Kayler e herança material de Normus para Sirius. A lâmina não cria magia nem concede sangue arcano. Forja, reparos e sete canais são verificáveis; manifestações foram registradas com custos crescentes. Função original, efeito integral da sétima manifestação e limite final não constam do registro público.",
      "category": "Relíquia do Véu Partido",
      "status": "Com Sirius",
      "origin": "Normus Kayler",
      "period": "Era das Coroas",
      "appearance": "Lâmina de sete canais condutores, reparada mais vezes do que ornamentada.",
      "abilities": [
        "Despertar",
        "Passo Celeste",
        "Corrente Partida",
        "Céu Descendente",
        "Tempestade Interior",
        "Julgamento Violeta",
        "Porta da Tempestade — efeito integral não publicado"
      ],
      "limitations": [
        "Sobrecarga nervosa",
        "Dependência do dom Kayler",
        "Limite final não registrado publicamente"
      ],
      "relations": [
        {
          "label": "Sirius Kayler",
          "to": "/personagens/sirius-kayler"
        },
        {
          "label": "Espada da Trovoada",
          "to": "/artefatos/espada-da-trovoada"
        }
      ],
      "events": [
        "Guerra dos Tronos",
        "Caça às Bruxas",
        "Retorno de Sirius"
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/archive-plates/celestiais-e-lancas-page.webp",
      "thumbnail": "/assets/images/archive-plates/celestiais-e-lancas-card.webp"
    },
    {
      "collection": "relics",
      "id": "aelysar",
      "slug": "aelysar",
      "name": "Aelysar",
      "subtitle": "O Arco da Primeira Raiz",
      "summary": "Arco destinado a Elara quando assumir o trono de Sylvaris, com seis flechas ligadas a responsabilidades da coroa.",
      "description": "Aelysar permanece sob custódia dos Círculos e será entregue a Elara somente após coroação legítima. Não escolhe soberano sozinho nem cria magia de sangue. Atas sucessórias e cadeia pública de custódia confirmam seis flechas ligadas a deveres. Função integral do Último Ramo e possibilidade de destruição não são publicadas.",
      "category": "Relíquia do Véu Partido",
      "status": "Guardada até a sucessão",
      "origin": "Sylvaris",
      "period": "Era das Coroas",
      "appearance": "Arco dourado-esverdeado cujo desenho acompanha seis encaixes de flecha. Não exibe corda quando guardado.",
      "abilities": [
        "Flecha da Raiz",
        "Lua Verde",
        "Memória",
        "Caminho",
        "Copa Silenciosa",
        "Último Ramo"
      ],
      "limitations": [
        "Não concede magia de sangue",
        "Flecha só retorna quando a obrigação correspondente é cumprida"
      ],
      "relations": [
        {
          "label": "Elara",
          "to": "/personagens/elara"
        },
        {
          "label": "Sucessão de Sylvaris",
          "to": "/sucessoes/sylvaris"
        }
      ],
      "events": [
        "Ritos sucessórios de Sylvaris"
      ],
      "truthStatus": "redacted",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/archive-plates/celestiais-e-lancas-page.webp",
      "thumbnail": "/assets/images/archive-plates/celestiais-e-lancas-card.webp"
    },
    {
      "collection": "legends",
      "id": "pacto-dos-descendentes",
      "slug": "pacto-dos-descendentes",
      "name": "O Pacto dos Descendentes",
      "subtitle": "A promessa de Normus e Aelwen",
      "summary": "Acordo reservado entre Normus e Aelwen que protegeu o descendente Kayler sem transformar qualquer herdeiro em propriedade do outro.",
      "description": "O pacto entre Normus e Aelwen existiu, protegeu Sirius e permanece relevante para a relação entre os herdeiros. Ele não constitui casamento, propriedade ou renúncia ao consentimento. O medalhão dividido, atas limitadas dos Círculos e ações de abrigo confirmam a existência do acordo. Alcance, cláusulas, contrapartidas e condições integrais são secretas e não aparecem no conteúdo público.",
      "category": "Pacto secreto",
      "status": "Ativo e incompleto",
      "origin": "Avernor",
      "location": "Sylvaris",
      "period": "Fim da Era das Coroas",
      "relations": [
        {
          "label": "Normus Kayler",
          "to": "/personagens/normus-kayler"
        },
        {
          "label": "Rainha Aelwen",
          "to": "/personagens/rainha-aelwen"
        },
        {
          "label": "Elara",
          "to": "/personagens/elara"
        },
        {
          "label": "Sirius Kayler",
          "to": "/personagens/sirius-kayler"
        }
      ],
      "truthStatus": "redacted",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/gallery/pacto-dos-descendentes-page.webp",
      "thumbnail": "/assets/images/gallery/pacto-dos-descendentes-card.webp"
    },
    {
      "collection": "worlds",
      "id": "elyra",
      "slug": "elyra",
      "name": "Elyra",
      "subtitle": "Mundo da Luz Imóvel",
      "summary": "Lugar sem noite observável, onde sombras permanecem mesmo após seus objetos se moverem.",
      "description": "Elyra é descrita como território de luz imóvel, sombras atrasadas e cidades claras sem habitantes visíveis. O Arquivo aceita a existência dos materiais retornados, não uma interpretação única do lugar. Amostras perdem cor sob o luar de Avernor; três relatos independentes registram sombra persistente e ausência de noite. População, extensão, passagem do tempo e natureza das cidades permanecem desconhecidas.",
      "category": "Outro mundo",
      "status": "Acesso não controlado",
      "origin": "Avernor",
      "curiosities": [
        "Relatos divergem sobre a passagem do tempo."
      ],
      "truthStatus": "witnessed",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/cosmology/elyra-page.webp",
      "thumbnail": "/assets/images/cosmology/elyra-card.webp"
    },
    {
      "collection": "peoples",
      "id": "orcs",
      "slug": "orcs",
      "name": "Orcs de Vul’Gar",
      "subtitle": "Clãs unidos pela Brasa",
      "summary": "Povo de cidades, clãs e rotas orientais que entende identidade como fogo compartilhado e responsabilidade recíproca.",
      "description": "A Brasa do Clã é um vínculo social mantido por lareiras comunais, testemunhos e obrigações. Não controla mentes nem produz magia. Clãs podem divergir, misturar-se ou expulsar chefes que quebram o abrigo comum. Vul’Gar designa uma região cultural; não uma horda ou vontade única.",
      "category": "Povo mortal",
      "status": "Confederações autônomas",
      "origin": "Clãs e cidades de Vul’Gar, ligados por rotas de poço e memória da Cicatriz Vermelha.",
      "location": "Vul’Gar e fronteira oriental",
      "beliefs": [
        "Brasa do Clã",
        "O nome adulto deve ser confirmado por serviço",
        "Água compartilhada suspende vinganças"
      ],
      "abilities": [
        "Resistência física",
        "Logística em terras áridas",
        "Diplomacia interclânica"
      ],
      "limitations": [
        "Não possuem magia verdadeira",
        "Acordos dependem dos clãs signatários",
        "Estereótipos humanos sabotam tratados"
      ],
      "relations": [
        {
          "label": "Kharza Gron",
          "to": "/personagens/kharza-gron"
        },
        {
          "label": "Facções de Avernor",
          "to": "/faccoes"
        }
      ],
      "truthStatus": "documented",
      "canonStatus": "canon",
      "spoilerLevel": "public",
      "image": "/assets/images/archive-plates/povos-de-avernor-page.webp",
      "thumbnail": "/assets/images/archive-plates/povos-de-avernor-card.webp"
    }
  ]
}
